import { OverallStatement } from "@/components";

export const ClimateStatement = () => {
  return <OverallStatement statementType="climate" />;
};
